import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { INVENTORY_SETUP_ACTIVE_LIST } from "../apiRoutes";
import { InventorySetupResponse } from "./useGetInventorySetup";

const fetchActiveInventorySetup = async () => {
  const response = await axiosAuth.get(INVENTORY_SETUP_ACTIVE_LIST);
  return response.data as InventorySetupResponse;
};

export const useGetActiveInventorySetup = (
  queryParams?: UseQueryOptions<InventorySetupResponse, Error, InventorySetupResponse, [string]>
) =>
  useQuery<InventorySetupResponse, Error, InventorySetupResponse, [string]>({
    queryKey: ["inevntory-active"],
    queryFn: fetchActiveInventorySetup,
    ...(queryParams as any),
  });


